module.exports = require("yargs");


//////////////////
// WEBPACK FOOTER
// external "yargs"
// module id = 17
// module chunks = 0